<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>fact_check</md-icon>
                    </div>
                    <h4 class="title">项目列表</h4>
                </md-card-header>
                <md-card-content>
                    <v-data-table :headers="headers" :items="tableData" :sort-by="['currentSort', 'currentSortOrder']" :items-per-page="5" :sort-desc="[false, true]" multi-sort hide-default-footer class="paginated-table table-striped table-hover">
                        <template v-slot:top>
                            <v-row justify="space-between">
                                <v-col class="d-flex" cols="6" sm="2">
                                    <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
                                </v-col>
                                <v-col class="d-flex" cols="6" sm="2">
                                    <v-text-field v-model="queryParams.name" label="查找" type="search" class="mb-3" clearable style="width: 200px"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.course="{ item }">{{ courseMap[item.course] }}</template>
                        <template v-slot:item.project="{ item }">{{ projectMap[item.project] }}</template>
                        <template v-slot:item.taskMode="{ item }">{{ taskModeMap[item.taskMode] }}</template>
                        <template v-slot:item.option="{ item }">
                            <md-button class="md-just-icon md-success md-round md-simple" @click.native="handleEdit(item)" style="padding-right: 30px;">
                                <md-icon>edit</md-icon>
                            </md-button>
                            <md-button class="md-just-icon md-danger md-round md-simple" @click.native="handleDelete(item)">
                                <md-icon>close</md-icon>
                            </md-button>
                        </template>
                    </v-data-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
                    </div>
                    <Pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total"> </Pagination>
                    <md-button class="md-success" @click="toNewProject">新 增</md-button>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>
<script>
import { Pagination } from '@/components'
import Fuse from 'fuse.js'
import Swal from 'sweetalert2'
import { listProject } from '@/api/project'
import { listCourse } from '@/api/course'
import { delProject } from '../../../api/project'
import { arrToObj } from '@/utils/util'

export default {
    components: {
        Pagination
    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            return this.pagination.total
        }
    },
    data() {
        return {
            headers: [
                { text: '课程', align: 'center', value: 'course' },
                { text: '项目', align: 'center', value: 'name' },
                { text: '负责人', align: 'center', value: 'manager' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            currentSort: 'name',
            currentSortOrder: 'asc',
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            searchQuery: '',
            propsToSearch: ['_name'],
            tableData: [],
            searchedData: [],
            courseMap: {},
            fuseSearch: null,
            queryParams: {}
        }
    },
    methods: {
        getCourseList() {
            listCourse({ getAll: true }).then((res) => {
                this.courseMap = arrToObj(res.data.rows, '_id', 'name')
                this.getList()
            })
        },
        getList() {
            let query = Object.assign(this.queryParams, this.pagination)
            listProject(query).then((res) => {
                this.tableData = res.data.rows
                this.pagination.total = res.data.total
            })
        },
        courseName(item) {
            const course = this.courseList.find((c) => c._id === item.course)
            return course.name
        },
        toNewProject() {
            this.$router.push({ path: './newproject' })
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                if (this.currentSortOrder === '_name') {
                    return a[sortBy].localeCompare(b[sortBy])
                }
                return b[sortBy].localeCompare(a[sortBy])
            })
        },
        handleEdit(item) {
            this.$router.push({ path: './newproject', query: item })
        },
        async handleDelete(item) {
            let result = await Swal.fire({
                title: '删除信息',
                text: `${item.name} 记录被删除后将无法恢复，请确认！`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: '确 定',
                cancelButtonText: '取 消',
                buttonsStyling: false
            })

            if (result.value) {
                const delResult = await delProject(item)
                if (delResult.code == 200) {
                    Swal.fire({
                        title: '已删除!',
                        text: `您已经删除 ${item.name}`,
                        type: 'success',
                        confirmButtonClass: 'md-button md-success btn-fill',
                        buttonsStyling: false
                    })
                    this.getList()
                }
            }
        }
    },
    mounted() {
        this.getCourseList()
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ['_course', '_name'],
            threshold: 0.3
        })
    },
    watch: {
        'queryParams.name'() {
            this.getList()
        },
        'pagination.currentPage'() {
            this.getList()
        },
        'pagination.perPage'() {
            this.getList()
        }
    }
}
</script>
<style lang="css" scoped>
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
</style>